const React = require('react')
const PropTypes = require('prop-types')
const SVGInline = require('react-svg-inline').default
const map = require('./social_icon_map')
const log = require('log').create('social icon') // eslint-disable-line

function SocialIcon({ glyph }) {
    const src = map[glyph]
    if (! src) throw new Error(`Invalid svg glyph ${glyph}`)

    return (
        <SVGInline svg={src} />
    )
}

SocialIcon.propTypes = {
    glyph: PropTypes.string.isRequired,
}

module.exports = SocialIcon
